/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionTypes, notificationAdded, notificationHidden, notificationRemoved} from './actions';
import {getType} from 'typesafe-actions';
import {NotificationWithVisibility} from './model';

export interface NotificationsState {
	notifications: NotificationWithVisibility[];
}

export interface RootStateWithNotifications {
	notifications: NotificationsState;
}

const initialNotificationsState = {
	notifications: []
};

const notificationsReducer = (state: NotificationsState = initialNotificationsState, action: ActionTypes): NotificationsState => {
	switch (action.type) {
		case getType(notificationAdded):
			return {...state, notifications: [...state.notifications, {entry: action.payload.notification, hidden: false}]};
		case getType(notificationHidden):
			return {
				...state,
				notifications: state.notifications.map((notification) => {
					if (notification.entry.identifier === action.payload.identifier)
						return {...notification, hidden: true};

					return notification;
				})
			};
		case getType(notificationRemoved):
			return {
				...state,
				notifications: state.notifications
					.filter((notification) => notification.entry.identifier !== action.payload.identifier)
			};
		default:
			return state;
	}
};

export default notificationsReducer;
